// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"114":"views-AdminViewsWrapper","630":"views-AppViewsWrapper","971":"CatalogueImportsView"}[chunkId] + "." + {"114":"603cf859","630":"603cf859","971":"002e670b"}[chunkId] + ".chunk.css";
};